import {
  Box,
  Button,
  FormControlLabel,
  makeStyles,
  Switch
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { editSwitchImageType } from 'src/store/modules/switchButton';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '16px',
    paddingRight: '26px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F5F5F5'
  }
}));
export default function SwitchImageType() {
  const switchImageType = useSelector(
    (state: RootState) => state.switchButton.switchImageType
  );

  const dispatch = useDispatch();
  const classes = useStyles();
  const [checked, setChecked] = useState(switchImageType === 'quard');
  const [position, setPosition] = useState(switchImageType);

  const handleChange = () => {
    setChecked(prev => !prev);
    const newImageType = !checked ? 'quard' : 'double';
    setPosition(newImageType);
    dispatch(editSwitchImageType(newImageType));
  };
  useEffect(() => {
    setChecked(switchImageType === 'quard');
    setPosition(switchImageType);
  }, [switchImageType]);
  return (
    <div>
      <Box className={classes.wrapper}>
        <span
          style={{
            fontSize: '0.875rem',
            fontWeight: 600,
            fontFamily: 'Archivo',
            letterSpacing: '0.0175rem'
          }}
        >
          IMAGE LAYOUT
        </span>
        <FormControlLabel
          control={
            <Switch checked={checked} onChange={handleChange} color="primary" />
          }
          label={position.toUpperCase()}
          labelPlacement="start"
        />
      </Box>
    </div>
  );
}
